import React from "react";
import { Image } from "@sitecore-jss/sitecore-jss-react";
const Preview = ({ url, playVedio }) => {
  return (
    <div
      onClick={() => {
        playVedio();
      }}
      className="overlay-image-wrapper"
    >
      {/* <img src={url} style={{ width: "100%" }} /> */}
      
      <Image field={url} className={'full-width'}></Image>
      <button className="player">
        <span>Play</span>
      </button>
    </div>
  );
};

export default Preview;
